import React from 'react';
import { Card, Form, Input, Select, Upload, Row, Col, Spin, Icon, Avatar } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { Prompt } from 'dva/router';
import { ButtonBar } from '../../../components';
import config from '../../../config';
import styles from './../styles.less';

const FormItem = Form.Item;

class Profile extends React.Component {
  constructor(props) {
    super(props);
    const { avatar } = props.app.user;
    this.state = {
      avatar,
      avatarFile: null,
      isSubmitted: false,
      avatarClass: 'widthResize',
      removedAvatar: false,
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'header/update',
      payload: {
        title: 'Component.User.Administration.Own.Edit.Title',
        description: 'Component.User.Administration.Own.Edit.Description',
      },
    });
    this.addTimeStamp(this.props.app.user.avatar);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.removedAvatar) {
      this.addTimeStamp(nextProps.app.user.avatar);
    }
  }

  onChange(e) {
    if (e.target.value) {
      this.props.form.validateFieldsAndScroll(['password_confirmation'], { force: true });
    } else if (!this.props.form.getFieldValue('password') && !this.props.form.getFieldValue('password_confirmation')) {
      this.props.form.resetFields(['password', 'password_confirmation']);
    }
  }

  addTimeStamp(img) {
    const avatar = img ? `${config['app.user_avatar.url'].resized}${img}` : '';
    this.setState({ avatar });
  }

  reset() {
    this.props.dispatch({
      type: 'app/goToRoute',
      payload: {
        routeName: 'LEAD_VISITS_LIST',
        projectId: this.props.app.currentProjectId,
      },
    });
  }

  compareToFirstPassword(rule, value, callback) {
    const form = this.props.form;
    const password = form.getFieldValue('password');

    if (value && value !== password) {
      callback(this.props.intl.formatMessage({ id: 'Common.ConfirmationPasswordError' }));
    } else {
      callback();
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({ isSubmitted: true });

        if (this.state.avatarFile || this.state.removedAvatar) {
          const payload = {
            avatar: this.state.avatarFile,
            id: this.props.app.user.id,
          };

          if (this.state.removedAvatar) {
            payload.remove = true;
          }

          this.props.dispatch({
            type: 'users/updateAvatar',
            payload,
          });
        }

        this.props.dispatch({
          type: 'users/updateProfile',
          payload: {
            id: this.props.app.user.id,
            avatar: this.state.avatar,
            ...values,
          },
        }).then(() => {
          this.props.dispatch({ type: 'app/showNotifications' });
          this.setState({ isSubmitted: false, avatarFile: '', avatarImg: '', removedAvatar: false });
        });
      }
    });
  }

  handleChange(info) {
    const reader = new window.FileReader();
    reader.onloadend = () => {
      const avatar = reader.result;
      const img = new Image();
      img.src = avatar;
      img.onload = () => {
        if (img.width < img.height) {
          this.setState({ avatarClass: 'heightResize' });
        }
      };
      this.setState({ avatarImg: avatar });
    };
    if (info.file) {
      reader.readAsDataURL(info.file);
      this.setState({ avatarFile: info.file });
    }
  }


  render() {
    const { getFieldDecorator, getFieldValue, isFieldsTouched } = this.props.form;
    const { user } = this.props.app;
    const { isSubmitted, avatarFile, avatarClass, removedAvatar } = this.state;
    const requiredPass = getFieldValue('password') || getFieldValue('password_confirmation');
    const locales = config['app.locales'];
    const avatar = this.state.avatarImg || this.state.avatar;

    return (
      <div>
        <Prompt
          when={!isSubmitted && (isFieldsTouched() || !!avatarFile || removedAvatar)}
          message={this.props.intl.locale}
        />
        <div className={styles.containerLarge}>
          <Spin spinning={!!this.props.loading.effects['users/updateProfile'] || !!this.props.loading.effects['users/updateUserPassword']}>
            <Form onSubmit={this.handleSubmit.bind(this)} className={styles.editUser}>
              <Card className={styles.noMarginTop}>
                <h3><FormattedMessage id="Component.User.Administration.Users.New.PersonalData" /></h3>
                <div className={styles.inputGroup}>
                  <Row type="flex" gutter={32}>
                    <Col span={12}>
                      <FormItem label={<FormattedMessage id="Component.User.Administration.Users.Edit.Form.fName" />}>
                        {getFieldDecorator('first_name', {
                          rules: [{
                            required: true,
                            min: 1,
                            max: 255,
                            message: this.props.intl.formatMessage({ id: 'Component.User.Administration.Users.Edit.Form.Error' }),
                          }],
                          initialValue: user.first_name,
                        })(
                          <Input maxLength={255} />,
                        )}
                      </FormItem>
                      <FormItem label={<FormattedMessage id="Component.User.Administration.Users.Edit.Form.lName" />}>
                        {getFieldDecorator('last_name', {
                          rules: [{
                            required: true,
                            min: 1,
                            max: 255,
                            message: this.props.intl.formatMessage({ id: 'Component.User.Administration.Users.Edit.Form.Error' }),
                          }],
                          initialValue: user.last_name,
                        })(
                          <Input maxLength={255} />,
                        )}
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <div className={styles.avatarWr}>
                        {avatar && <Icon type="close-circle" onClick={() => this.setState({ removedAvatar: true, avatar: '' })} />}
                        <Upload
                          name="avatar"
                          accept=".jpg,.jpeg,.png,.gif"
                          listType="picture"
                          showUploadList={false}
                          beforeUpload={() => false}
                          onChange={this.handleChange.bind(this)}
                        >
                          <Spin spinning={!!this.props.loading.effects['users/updateAvatar']}>
                            {avatar ?
                              <Avatar src={avatar} className={styles[avatarClass]} /> :
                              <Avatar icon="user" className={styles[avatarClass]} />
                            }
                          </Spin>
                        </Upload>
                      </div>
                    </Col>
                  </Row>
                </div>

                <div className={styles.inputGroup}>
                  <Row type="flex" gutter={32}>
                    <Col span={12}>
                      <FormItem label={<FormattedMessage id="Component.User.Administration.Users.Edit.Form.Email" />}>
                        {getFieldDecorator('email', {
                          rules: [{
                            min: 1,
                            max: 255,
                            required: true,
                            type: 'email',
                            message: this.props.intl.formatMessage({ id: 'Component.User.Administration.Users.Edit.Form.Error' }),
                          }],
                          initialValue: user.email,
                        })(
                          <Input maxLength={255} />,
                        )}
                      </FormItem>
                    </Col>
                  </Row>
                </div>
                <div className={styles.inputGroup}>
                  <Row type="flex" gutter={32}>
                    <Col span={12}>
                      <FormItem label={<FormattedMessage id="Component.User.Administration.Users.Edit.Form.Password" />}>
                        {getFieldDecorator('password', {
                          rules: [{
                            required: requiredPass,
                            message: this.props.intl.formatMessage({ id: 'Component.User.Administration.Users.Edit.Form.Error' }),
                          }],
                          onKeyUp: this.onChange.bind(this),
                          validateTrigger: ['onChange', 'onKeyUp'],
                        })(
                          <Input maxLength={255} type="password" autoComplete="new-password" />,
                        )}
                      </FormItem>
                    </Col>
                  </Row>
                  <Row type="flex" gutter={32}>
                    <Col span={12}>
                      <FormItem label={<FormattedMessage id="Component.User.Administration.Users.Edit.Form.Password2" />}>
                        {getFieldDecorator('password_confirmation', {
                          rules: [{
                            required: requiredPass,
                            message: this.props.intl.formatMessage({ id: 'Component.User.Administration.Users.Edit.Form.Error' }),
                          }, {
                            validator: this.compareToFirstPassword.bind(this),
                          }],
                          onKeyUp: this.onChange.bind(this),
                          validateTrigger: 'onKeyUp',
                        })(
                          <Input maxLength={255} type="password" autoComplete="new-password" />,
                        )}
                      </FormItem>
                    </Col>
                  </Row>
                </div>
                <Row type="flex" gutter={32}>
                  <Col span={12}>
                    <FormItem label={<FormattedMessage id="Component.User.Administration.Users.Edit.Form.Lang" />}>
                      {getFieldDecorator('locale', {
                        rules: [{
                          required: true,
                          message: this.props.intl.formatMessage({ id: 'Component.User.Administration.Users.Edit.Form.Error' }),
                        }],
                        initialValue: this.props.app.locale,
                      })(
                        <Select
                          style={{ width: '100%' }}
                        >
                          {
                            locales.map(item => (
                              <Select.Option value={item} key={item}>
                                <FormattedMessage id={`Common.Languages.Name.${item}`} />
                              </Select.Option>
                            ),
                            )
                          }
                        </Select>,
                      )}
                    </FormItem>
                  </Col>
                </Row>
              </Card>
              <ButtonBar cancelAction={this.reset.bind(this)} />
            </Form>
          </Spin>
        </div>
      </div>
    );
  }
}

export default connect(
  ({ app, users, loading }) => ({ app, users, loading }))(Form.create()(injectIntl(Profile)));



// WEBPACK FOOTER //
// ./src/components/UsersAdministration/Profile/Profile.js